<template>
  <header class="nav">
      <div class="nav-content">
        <router-link :to="{ name: 'Home'}"
        >
          <p class="nav-header">Where in the World?</p>
        </router-link>
        
        <!-- <div class="nav-mode">
          <i class="fas fa-adjust"></i>
          <p class="nav-mode-text">Dark Mode</p>
        </div> -->
      </div>
  </header>
</template>

<script>
export default {
    
}
</script>

<style lang="scss">

.nav{
    width: 100%;
    font-size: .875rem;
    padding: 1.5rem 0;
    margin-bottom: .75rem;
    background-color: hsl(0, 0%, 100%); 
    box-shadow: 0 3px 5px rgba($color: #000000, $alpha: .08);
    &-content {
        display: flex;
        justify-content: space-between;
        width: 90%;
        max-width: 82.5rem;
        margin: 0 auto;
        a {
          text-decoration: none;
          color: inherit;
          cursor: none;
          @media (min-width: 48em) {
            cursor: pointer;
          }
        }
    }
    &-header {
        font-weight: 800;
    }
    &-mode {
        display: flex;
        align-items: baseline;
        font-weight: 600;
        
        &-text {
            margin-left: 5px;
        }
    }
}
</style>